/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentPlans/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Header from './Header/index'
import React from 'react'
import Steps from './Steps/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TreatmentPlans({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="TreatmentPlans.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-wdATi': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--mr-2-wdATi': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="TreatmentPlans.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Header
  viewPath={`${viewPath}/Header`}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceXs}
 marginBottom={0}
/>
<Steps
  viewPath={`${viewPath}/Steps`}
/>
</div>
{children}
</React.Fragment>)
}